var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-hero" }, [
    _c(
      "div",
      {
        staticClass: "chat-hero__line ia-texto-hero chat-hero__line--saudacao"
      },
      [_vm._v(_vm._s(_vm.saudacao))]
    ),
    _c(
      "div",
      {
        staticClass: "chat-hero__line ia-texto-hero chat-hero__line--headline"
      },
      [_vm._v(_vm._s(_vm.headline))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }